import React, { useContext } from 'react';
import {GetWeekschemaById_weekById_employments_employee_leaves} from '../../types/GensonGRM';
import {observer} from "mobx-react";
import { StateContext } from '../../store/StateContext';

export interface EmployeeAbsenceProps {
  leave: GetWeekschemaById_weekById_employments_employee_leaves;
}

const EmployeeAbsence: React.FC<EmployeeAbsenceProps> = observer((props) => {
  const state = useContext(StateContext);

  return (
    <div className="row-absence">
      <div className="row">
        <div className="col-dossier">
          Verlof
        </div>
        <div className="col-date">
          {state.dateFormatter.format(new Date(props.leave.startedAt))}
          {' - '}
          {state.dateFormatter.format(new Date(props.leave.endedAt))}
        </div>
      </div>
    </div>
  )
});

export default EmployeeAbsence;
